import React from 'react';
import { FormattedMessage } from 'react-intl';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import { withTranslate } from 'shared/hocs/withTranslate';
import { numberWithSpaces } from 'shared/helpers/common';

import RectanglesOptions from 'shared/components/UI/RectanglesOptions/RectanglesOptions';
import NumberInputWithSlider from 'shared/components/UI/NumberInputWithSlider/NumberInputWithSlider';
import Button from 'shared/components/UI/Button/Button';
import LeasingModal from 'shared/components/LeasingOnlineBanner/LeasingModal/LeasingModal';

import { calculateMonthlyPaymentV2 } from 'shared/helpers/leasing/utils';
import headerCar from 'shared/assets/images/articles/leasing/header-car.png';

// eslint-disable-next-line css-modules/no-unused-class
import s from './LeasingCalculatorForm.css';

const MIN_PRICE = 140000;
const MAX_PRICE = 7000000;

const MIN_PRECENT_PREPAID = 0.2;
const MAX_PRECENT_PREPAID = 0.4;
const DEF_PRECENT_PREPAID = 0.3;

const DEF_PRICE = 500000;

class LeasingCalculatorForm extends React.Component {
  static propTypes = {};

  static defaultProps = {};

  state = {
    priceValue: DEF_PRICE,
    prepaidValue: DEF_PRICE * DEF_PRECENT_PREPAID,
    term: 84,
    prepaidMin: DEF_PRICE * MIN_PRECENT_PREPAID,
    prepaidMax: DEF_PRICE * MAX_PRECENT_PREPAID,
    showModal: false,
  };

  // onPrepaidChange = value => {

  // };

  onPriceInputChange = (name, value) => {
    // console.log('onChangeInput', name, value);
    this.setState({
      priceValue: value,
      prepaidMin: value * MIN_PRECENT_PREPAID,
      prepaidMax: value * MAX_PRECENT_PREPAID,
    });
  };

  onPriceSliderChange = (name, value) => {
    // console.log('onChangeSlider', name, value);
    this.setState({
      priceValue: value,
      prepaidMin: value * MIN_PRECENT_PREPAID,
      prepaidMax: value * MAX_PRECENT_PREPAID,
    });
  };
  onPrepaidInputChange = (name, value) => {
    // console.log('onChangePrepaidInput', name, value);
    this.setState({ prepaidValue: value });
  };

  onPrepaidSliderChange = (name, value) => {
    // console.log('onChangePrepaidSlider', name, value);
    this.setState({ prepaidValue: value });
  };

  onTermChange = (name, value) => {
    // console.log('onChangePrepaidSlider', name, value);
    this.setState({ term: value });
  };

  onInputBlur = (name, value) => {
    console.log(name, value);
  };

  showModal = () => {
    this.setState({ showModal: true });
  };

  closModal = () => {
    this.setState({ showModal: false });
  };

  render() {
    // const { t, changeHandler, onSubmitHandler, prepaid, price, terms, term } = this.props;
    // const { errMin, errMax, disabledSubmit } = this.state;
    // const pricePlaceholder = numberWithSpaces(price);
    const YEAR = 2015;
    const { priceValue, prepaidValue, term, prepaidMin, prepaidMax } = this.state;

    const terms = [12, 24, 36, 48, 60, 72, 84];

    const monthlyPriceUah = calculateMonthlyPaymentV2({
      year: YEAR,
      term,
      price: priceValue,
      prepaid: prepaidValue,
      comission: 5000,
      rate: 45,
    });

    const advert = {
      id: 1,
      permalink: '/leasing',
      year: YEAR,
      characteristics: {},
      capacity: 1000,
      photos: [{ image: headerCar }],
      vehreg_info: {},
      price: [
        { value: priceValue, exchange_rate: 1, currency: 'uah' },
        { value: priceValue, exchange_rate: 1, currency: 'usd' },
      ],
    };

    const leasingParams = {
      term,
      monthlyPayment: 1,
      extendedParams: {
        monthlyPaymentUAH: monthlyPriceUah,
        monthlyPaymentUAHFormatted: numberWithSpaces(monthlyPriceUah),
        prepaidUAH: prepaidValue,
        priceUAH: priceValue,
      },
    };
    return (
      <div className={s.root}>
        <NumberInputWithSlider
          className="mrb-18"
          title="Стоимость авто, грн"
          name="price"
          min={MIN_PRICE}
          max={MAX_PRICE}
          value={priceValue * 1}
          onInputChange={this.onPriceInputChange}
          onSliderChange={this.onPriceSliderChange}
          onInputBlur={this.onInputBlur}
        />

        <NumberInputWithSlider
          className="mrb-18"
          title="Первоначальный взнос"
          name="prepaid"
          min={prepaidMin}
          max={prepaidMax}
          value={prepaidValue * 1}
          onInputChange={this.onPrepaidInputChange}
          onSliderChange={this.onPrepaidSliderChange}
          onInputBlur={this.onInputBlur}
        />

        <RectanglesOptions
          title="Срок финансирования, месяцев"
          options={terms}
          selected={term}
          name="term"
          onChange={this.onTermChange}
        />

        <div className={`${s.monthlyTitle} mrb-4`}>
          <FormattedMessage id={'Ежемесячный платеж'} />
        </div>
        <div className={`${s.monthlyPrice} mrb-20`}>
          {numberWithSpaces(monthlyPriceUah)} ₴/
          <FormattedMessage id={'мес'} />
        </div>

        <Button type="button" text="Оставить заявку" onClick={this.showModal} />
        <LeasingModal
          // partner="hapai"
          toggleLeasingModal={this.closModal}
          show={this.state.showModal}
          leasingParams={leasingParams}
          advert={advert}
        />
      </div>
    );
  }
}

export default withStyles(s)(withTranslate(LeasingCalculatorForm));



// WEBPACK FOOTER //
// ./src/shared/components/Article/Leasing/LeasingCalculatorForm/LeasingCalculatorForm.js